import { Component } from '@verndale/core';
import serialize from 'form-serialize';
import axios from 'axios';
import MicroModal from 'micromodal';
import { constEvent } from '../utils/constants';

import { SERIALIZE_SETTINGS } from '../utils/default-settings';

import { dispatchGenericEvent } from '../utils/dispatch-events';

class Module extends Component {
  setupDefaults() {
    this.id = this.el.closest('.generic-modal').id;
    this.dom = {
      $el: this.el,
      $productsContainer: this.el._$(
        '.modal-product-compare__products-container'
      ),
      $closeTrigger: null
    };
    this.getProductsUrl = this.dom.$el.getAttribute('data-get-products-url');
    this.removeProductUrl = this.dom.$el.getAttribute(
      'data-remove-product-url'
    );
    this.addToCartUrl = this.dom.$el.getAttribute('data-add-to-cart-url');
    this.addToListUrl = this.dom.$el.getAttribute('data-add-to-list-url');
    this.showMessageClass = 'modal-product-compare__message--show';
    this.showMessageCenterClass = 'modal-product-compare__message--show-center';
    this.modalId = null;
    this.closeTrigger = null;

    this.init();
  } //setupDefaults

  init() {
    const { $el } = this.dom;

    const $genericModal = $el.closest('.generic-modal');
    if ($genericModal) {
      this.modalId = $genericModal.getAttribute('id') || null;
      this.closeTrigger = $genericModal._$$('[data-generic-modal-close]');
    }

    document.addEventListener('click', e => {
      console.log('element Id', e.target.parentNode.getAttribute('class'));
      if (e.target.parentNode.getAttribute('id') === 'cm_add_list_btn') {
        const $customModal = document.getElementById('modal-product-compare');
        if ($customModal){
          $customModal.classList.remove('generic-modal--open');
        }
      }
    });//close modal on addToList

  } //init

  addListeners() {
    document._on(constEvent.COMPARE_PRODUCTS, this.openModal.bind(this));
    this.closeTrigger?._on('click', this.forceCloseModal.bind(this));
  } //addListeners

  loadProducts() {
    const { $el, $productsContainer } = this.dom;
    let productsToCompare = '',
      compareProducts = localStorage.getItem(
        constEvent.COMPARE_LOCAL_STORAGE_NAME
      );

    if (
      typeof compareProducts !== 'undefined' &&
      JSON.parse(compareProducts).length > 0
    ) {
      compareProducts = JSON.parse(compareProducts);
    } else {
      compareProducts = [];
    }

    compareProducts.forEach((item, index) => {
      productsToCompare += `${item.number}${
        index < compareProducts.length - 1 ? ',' : ''
      }`;
    });

    $productsContainer.classList.add('loading');
    $el.classList.add('is-loading');

    axios({
      method: 'get',
      url: `${this.getProductsUrl}?products=${productsToCompare}`,
      headers: {
        'content-type': 'application/json'
      }
    }).then(response => {
      const { success, body, message } = response.data;
      let productsHtml = '';

      if (success) {
        if (body && body.products && body.products.length) {
          productsHtml = `<div class="modal-product-compare__responsive-table rtable__${body.products.length}products">`;
          body.attributes.forEach((attribute, index) => {
            productsHtml += `<div style="order: ${index + 1};" class="rtable__cell rtable__cell-left-title">${attribute.show_label ? `<h4>${attribute.label}</h4>` : ''}</div>`;
          });
          productsHtml += `<div style="order: ${body.attributes.length + 1};" class="rtable__cell rtable__cell-left-title"></div>`;
          body.products.forEach((product, index) => {
            const isLastProduct = index + 1 === body.products.length;
            product.attributes.forEach((attribute, index) => {
              if (attribute.property === 'is_name') {
                productsHtml += `<div style="order: ${index + 1};" class="rtable__cell ${isLastProduct ? 'rtable__cell-last-product' : ''} ${(index + 1) % 2 === 0 ? 'rtable__cell--even' : 'rtable__cell--odd'}">
                                  <button type="button" class="rtable__remove-button" aria-label="remove" data-product-id="${product.id}"></button>
                                  <a href="${product.url}">${attribute.value}</a>
                                </div>`;
              } else if (attribute.property === 'is_item_number') {
                productsHtml += `<div style="order: ${index + 1};" class="rtable__cell ${isLastProduct ? 'rtable__cell-last-product' : ''} ${(index + 1) % 2 === 0 ? 'rtable__cell--even' : 'rtable__cell--odd'}">
                                  <h3>${attribute.value}</h3>
                                </div>`;
              } else if (attribute.property === 'is_mage') {
                productsHtml += `<div style="order: ${index + 1};" class="rtable__cell ${isLastProduct ? 'rtable__cell-last-product' : ''} ${(index + 1) % 2 === 0 ? 'rtable__cell--even' : 'rtable__cell--odd'}">
                                  <img src="${attribute.value}" alt="${attribute.description}">
                                </div>`;
              } else {
                productsHtml += `<div style="order: ${index + 1};" class="rtable__cell ${isLastProduct ? 'rtable__cell-last-product' : ''} ${(index + 1) % 2 === 0 ? 'rtable__cell--even' : 'rtable__cell--odd'}">
                                  <h5>${body.attributes[index].label}</h5>
                                  <p>${attribute.value}</p>
                                </div>`;
              }
            });
            productsHtml += `<div style="order: ${body.attributes.length + 1};" class="rtable__cell rtable__cell-cta-wrapper">
                              <div class="modal-product-compare__cta-container">`;
            if (product.price) {
              productsHtml += `<h4 class="modal-product-compare__cta-price">${product.price.old_value ? `<span class="modal-product-compare__cta-old-price">${product.price.old_value}</span> ` : ''}${product.price.value}</h4>`;
            }
            if (product.show_add_to_cart_btn) {
              productsHtml += `<form action="${this.addToCartUrl}"
                                  class="modal-product-compare__add-to-cart-form">
                                  <input type="hidden" name="product_id" value="${product.id}">
                                  <input type="hidden" name="quantity" value="1">
                      
                                  <button type="submit" class="btn btn--primary btn--cart-icon modal-product-compare__cta-add-to-cart"
                                    data-success-label=${product.added_to_cart_btn_label}">
                                    <span>${product.add_to_cart_btn_label}</span>
                                  </button>
                                </form>`;
            }

            if (product.show_select_lot_btn) {
              productsHtml += `<form action=""
                                  class="modal-product-compare__select-specific-lot-form">
                                  <input type="hidden" name="product_id" value="${product.id}">
                                  <input type="hidden" name="quantity" value="1">
                      
                                  <button type="button" data-generic-modal-open="modal-lot-information" class="btn btn--primary btn--cart-icon modal-product-compare__cta-select-specific-lot"
                                    data-success-label=${product.select_lot_btn_label}" data-atcc-number="${product.id}">
                                    <span>${product.select_lot_btn_label}</span>
                                  </button>
                                </form>`;
            }

            if (product.show_add_to_list_btn) {
              productsHtml += `<form action="${this.addToListUrl}"
                                  class="modal-product-compare__add-to-list-form">
                                  <input type="hidden" name="product_id" value="${product.id}">
                                  <input type="hidden" name="quantity" value="1">
                                  <button type="submit" class="btn btn--flat btn--tag-icon modal-product-compare__cta-add-to-list">
                                    <span>${product.add_to_list_btn_label}</span>
                                  </button>
                                </form>`;
            }
            productsHtml += '<span class="modal-product-compare__message"></span>'
            if (product.show_determine_tour_distributor_label) {
              productsHtml += `<a href="${product.determine_your_distributor_url}" class="modal-product-compare__determine-your-distributor-link btn btn--primary ">${product.determine_your_distributor_label}</a>`;
            }
            productsHtml += ` </div>
                            </div>`;
          });

          productsHtml += '</div>';
          productsHtml += `<div class="loader-wrapper">
                              <div class="loader"></div>
                          </div>`;

        } else {
          productsHtml += `<p>${message}<p>
                          <div class="loader-wrapper">
                              <div class="loader"></div>
                          </div>`;
        }
        $productsContainer.innerHTML = productsHtml;
        const $form = $el._$$('.modal-product-compare__add-to-cart-form');
        const $formAddToList = $el._$$('.modal-product-compare__add-to-list-form');
        const $formSelectLotBtn = $el._$$('.modal-product-compare__select-specific-lot-form .btn');
        const $removeProductButton = $el._$$('.rtable__remove-button');
        $form?._on('submit', this.addToCart.bind(this));
        $formAddToList?._on('submit', this.addToList.bind(this));
        $removeProductButton?._on('click', this.removeProduct.bind(this));
        $formSelectLotBtn?._on('click', this.hideModal.bind(this));
      }
    }).finally(() => {
      $productsContainer.classList.remove('loading');
      $el.classList.remove('is-loading');
    });
  } //loadProducts

  hideModal() {
    MicroModal.close('modal-product-compare');
  }

  openModal(e) {
    this.loadProducts();
    MicroModal.show(this.id, {
      closeTrigger: 'data-generic-modal-close',
      openClass: 'generic-modal--open'
    });
    setInterval(() => {
      this.getHeight();
    }, 250);
  } //openModal

  hideMessage($message) {
    $message.classList.remove(this.showMessageClass);
    $message.classList.remove(this.showMessageCenterClass);
  } //hideMessage

  addToCart(e) {
    e.preventDefault(e);
    const $form = e.currentTarget;
    const $message = $form
      .closest('.rtable__cell-cta-wrapper')
      ._$('.modal-product-compare__message');
    const $btnAddToCart = $form._$('button[type="submit"]');
    const formData = serialize($form, SERIALIZE_SETTINGS);
    const addToCartEndpoint = $form.getAttribute('action');
    this.hideMessage($message);
    $btnAddToCart.disabled = true;

    this.post(addToCartEndpoint, formData)
      .then(response => {
        const { success, message, body } = response?.data;
        if (success) {
          $btnAddToCart.classList.remove('btn--primary');
          $btnAddToCart.classList.add('btn--tertiary');
          const successLabel = $btnAddToCart.getAttribute('data-success-label');
          $btnAddToCart._$('span').innerText = successLabel;

          // dispatch custom event for GA4 add_to_cart on addtional required products
          const event = new CustomEvent('customAddedToCart', { detail: body });
          document.dispatchEvent(event);
        } else {
          $message.innerHTML = message;
          $message.classList.add(this.showMessageCenterClass);
        }
      })
      .finally(() => {
        $btnAddToCart.disabled = false;
      });
  } //addToCart

  addToList(e) {
    e.preventDefault();
    const $formAddToList = e.currentTarget;
    const formData = serialize($formAddToList, SERIALIZE_SETTINGS);

    if (dispatchGenericEvent) {
      dispatchGenericEvent(
        constEvent.SHOW_ADD_TO_LIST_MODAL,
        formData.product_id
      );
    }
  } //addToList

  post(endpoint, data) {
    return axios({
      method: 'post',
      url: endpoint,
      data,
      headers: {
        'content-type': 'application/json'
      }
    });
  } //post

  removeProduct(e) {
    const productId = e.currentTarget.getAttribute('data-product-id');
    const compareProducts = JSON.parse(
      localStorage.getItem(constEvent.COMPARE_LOCAL_STORAGE_NAME)
    );
    compareProducts.forEach((item, index) => {
      if (item.number === productId) {
        compareProducts.splice(index, 1);
        const $checkbox = document._$(
          `input[name="compare"][data-product-id="${productId}"]`
        );
        if ($checkbox) {
          $checkbox.checked = false;
        }
      }
    });
    localStorage.setItem(
      constEvent.COMPARE_LOCAL_STORAGE_NAME,
      JSON.stringify(compareProducts)
    );
    dispatchGenericEvent(constEvent.ADD_TO_COMPARE_LIST);
    this.loadProducts();
    if (compareProducts.length < 2) {
      const $customModal = document.getElementById('modal-product-compare');
      if ($customModal) {
        $customModal.classList.remove('generic-modal--open');
      }
    }
  } //removeProduct

  forceCloseModal(e) {
    if (e.target.hasAttribute('data-generic-modal-close')) this.hideModal();
  } //forceCloseModal

  hideModal() {
    if (this.modalId) MicroModal.close(this.modalId);
  } //hideModal

  getHeight(){
    if ($(window).width() > 600) {
      const $firstRow = $('.rtable__cell:first-child').outerHeight();
      $('.rtable__cell[style="order: 2;"]').css({
        'background-color' : '#ffffff',
        position : 'sticky',
        top : $firstRow
      });
    }
  } //Height of table row

}

export default Module;
